import React from "react";
import YouTube from "react-youtube";

import "../../styles/youtube.scss"

const YouTubeVideo = ({ videoId, videoTitle }) => {
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            controls: 0,     // Hide controls
            rel: 0,          // Disable related videos
            modestbranding: 1, // Hide YouTube logo
            showinfo: 0,     // Hide video title
            loop: 1,
            playlist: videoId, // To be able to loop the video
            playsinline: 0,
            fs: 1
        },
    };

    return (
        <div id="YoutubeVideo">
            <div className="youtubeText">
                <h2>Hur beställer du tryck via vår hemsida?</h2>
            </div>
            <YouTube
                videoId={videoId}
                className="youtubePlayer"
                title={`Enkelt att beställa ${videoTitle} hos Attitude.se`}
                opts={opts}
            />
            <div className="youtubeText">
                <h3>{`Beställ ${videoTitle}`}</h3>
            </div>
        </div>
    );
};

const YouTubeVideoWithoutText = ({ videoId }) => {
    const opts = {
        height: '100%',
        width: '100%',
        playerVars: {
            controls: 0,     // Hide controls
            rel: 0,          // Disable related videos
            modestbranding: 1, // Hide YouTube logo
            showinfo: 0,     // Hide video title
            loop: 1,
            playlist: videoId, // To be able to loop the video
            playsinline: 0,
            fs: 1
        },
    };

    return (
        <div id="YoutubeVideo" className="noText">
            <YouTube
                videoId={videoId}
                className="youtubePlayer"
                title={`Enkelt att beställa tryck kläder, kontorsmaterial och annat hos Attitude.se`}
                opts={opts}
            />
        </div>
    );
};

export { YouTubeVideoWithoutText }
export default YouTubeVideo;
